import React from 'react';
import Proptypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import cx from 'classnames';
import Notification from '@xingternal/malt-notification';
import { IconCoreNotification } from '@xingternal/malt-icon';
import { TrackedLink, withTracking, eitherOr } from '../xing-tracking';
import trackings from '../trackings';

import styles from './notification-center.css';

const NotificationCenter = ({ className, count, intl: { formatMessage } }) => {
  const trackingConditions = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    sc_o_PropActionOrigin: eitherOr(count),
  };

  return (
    <TrackedLink
      trackingKey="notification_center"
      conditions={trackingConditions}
      className={cx(styles.container, className)}
      href="/notification-center"
    >
      <div className={styles.icons}>
        <IconCoreNotification className={styles.notification} />
        {Boolean(count) && (
          <Notification className={styles.count} count={count} max={99} />
        )}
      </div>
      <span className={styles.label}>
        {formatMessage({
          id: 'NOTIFICATION_CENTER_LINK',
        })}
      </span>
    </TrackedLink>
  );
};

NotificationCenter.propTypes = {
  className: Proptypes.string,
  count: Proptypes.number,
  intl: intlShape,
};

export default injectIntl(withTracking(trackings)(NotificationCenter));
